
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-mawoo-pets",
      function () {
        return require("private-next-pages/about-mawoo-pets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-mawoo-pets"])
      });
    }
  